export const TRIGGER_LOGIN = 'triggerLogin'
export const TOKEN_EXPIRED = 'tokenExpired'
export const BLOCK_NAVIGATION_FROM_SHELL = 'blockNavigationFromShell'
export const TRIGGER_OPEN_CONTINUE_SESSION_DIALOG = 'continueSession'
export const ORGANIZATION_SWITCHED = 'organizationSwitched'
